export enum ContractType {
	support,
	software,
}
